import CryptoJS from 'crypto-js';

/**
 * Calculates SHA1 of given file.
 *
 * @param  {File} file      File instance.
 * @param  {number} chunkSize Size of a chunk to calculate SHA1.
 * @returns {string}           SHA1 of a file.
 */
export const calculateFileSHA1 = async (file, chunkSize = 10485760) => {
    let hash = CryptoJS.algo.SHA1.create();
    let start = 0;

    /**
     * Reads chunk of a file.
     *
     * @param  {File} file File instance
     * @param  {number} start Start of the chunk
     * @param  {number} chunkSize Size of the chunk
     * @returns {Promise} Promise
     */
    const readChunk = (file, start, chunkSize) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            const slice = file.slice(start, start + chunkSize);

            fileReader.onload = () => resolve(new Uint8Array(fileReader.result));
            fileReader.onerror = reject;
            fileReader.readAsArrayBuffer(slice);
        });
    };

    while (start < file.size) {
        const slice = await readChunk(file, start, chunkSize);

        hash = hash.update(CryptoJS.lib.WordArray.create(slice));
        start += chunkSize;
    }

    hash.finalize();

    return hash._hash.toString();
};
